import { safeRandomUUID } from '@/shared-utilities';

export function generateNewUUID(): string {
  return `00000000-0000-0000-0000-${safeRandomUUID().slice(-12)}`;
}

export function isNewUUID(id: string | null | undefined): boolean {
  return id?.startsWith('00000000-0000-0000') === true;
}
